import React from 'react';
import { connect } from 'react-redux';
import { reduxForm, FormSection, change, getFormSubmitErrors } from 'redux-form';
import { RaisedButton, Snackbar } from 'material-ui';
import { red400, green800 } from 'material-ui/styles/colors';
import _ from 'lodash';
import { MANUAL_TRIGGER_FORM_ID, CAMPAIGN_FORM_KEYS as FORM_KEYS } from 'dash-front/constants';
import { TriggerForm } from 'dash-front/campaign/components/Form/RuleForm';
import ConditionForm from 'dash-front/campaign/components/Form/ConditionForm';
import PayloadForm from 'dash-front/campaign/components/Form/PayloadForm';
import ErrorComponent from 'dash-front/campaign/components/Form/Error';
import { withTriggerType } from 'dash-front/campaign/enhancers';
import { createTrigger } from 'dash-front/campaign/actions/trigger';
import { handleServerError } from 'dash-front/actions/helpers';
import { generateRoutingKey } from './schema';

const mockData = {
    conditions: {
        sportId: '1',
        ttId: '46',
        eventId: '5095488',
        homeId: '10202',
        awayId: '8410',
        incident_type: 'goal'
    },
    payload: {
        incidentId: 5095488,
        awayId: 8410,
        homeId: 10202,
        sportId: 1,
        tournamentId: 46,
        eventId: 2511282
    },
    triggerType: 'enet_event_incident'
};

const withTriggerTypeHOC = withTriggerType(MANUAL_TRIGGER_FORM_ID);

const mapDispatchToPropsTriggerForm = dispatch => {
    return {
        onTriggerChange: () => {
            dispatch(change(MANUAL_TRIGGER_FORM_ID, FORM_KEYS.RULES.CONDITIONS.ARRAY, { sportId: '1' }));
            dispatch(change(MANUAL_TRIGGER_FORM_ID, 'payload', {}));
        }
    };
};

const TriggerFormEnhanced = connect(null, mapDispatchToPropsTriggerForm)(TriggerForm);

const ConditionFormEnhanced = withTriggerTypeHOC(ConditionForm);

const PayloadFormEnhanced = withTriggerTypeHOC(PayloadForm);

const ErrorComponentEnhanced = connect(state => ({
    value: _.get(getFormSubmitErrors(MANUAL_TRIGGER_FORM_ID)(state), 'errors')
}))(ErrorComponent);

const EnvComponent = () => {
    const env = process.env.NODE_ENV;
    const color = env === 'dev' ? green800 : red400;
    return (
        <h2>
            ENVIRONMENT: <span style={{ color }}>{env}</span>
        </h2>
    );
};

class ManualTriggerForm extends React.PureComponent {
    constructor(props, ctx) {
        super(props, ctx);
        this.state = {
            showBadge: false
        };
    }

    componentDidMount() {
        this.props.initialize(mockData);
        window.onbeforeunload = () => 'Are you sure to refresh the page?';
    }

    componentWillReceiveProps({ submitSucceeded }) {
        if (this.props.submitting && submitSucceeded) {
            this.setState({ showBadge: true });
            setTimeout(() => this.setState({ showBadge: false }), 1000);
        }
    }

    componentWillUnmount() {
        window.onbeforeunload = null;
    }

    render() {
        const { reset, submit, valid } = this.props;
        return (
            <div>
                <EnvComponent />
                <h3>Manual trigger</h3>
                <div>
                    <ErrorComponentEnhanced />
                </div>
                <TriggerFormEnhanced />
                <FormSection name={FORM_KEYS.RULES.CONDITIONS.ARRAY}>
                    <ConditionFormEnhanced allRequired />
                </FormSection>
                <FormSection name={'payload'}>
                    <h4>Payload</h4>
                    <PayloadFormEnhanced />
                </FormSection>
                <div>
                    <RaisedButton primary onTouchTap={submit} label={'Submit'} />
                    <RaisedButton secondary style={{ marginLeft: 12 }} label={'Clear'} onTouchTap={reset} />
                </div>
                <Snackbar open={this.state.showBadge} message="Success" autoHideDuration={4000} />
            </div>
        );
    }
}

const mapData = value => {
    const { [FORM_KEYS.RULES.KEY]: triggerType, [FORM_KEYS.RULES.CONDITIONS.ARRAY]: conditions, payload } = value;
    const routingKey = generateRoutingKey(triggerType, conditions);
    return { routingKey, payload };
};

const onSubmit = (value, dispatch) => {
    const mappedData = mapData(value);
    return dispatch(createTrigger(mappedData)).then(handleServerError);
};

export default reduxForm({ form: MANUAL_TRIGGER_FORM_ID, onSubmit })(ManualTriggerForm);



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/containers/Campaign/ManualTrigger.js
 **/